import type { CultivarArea } from '@/types/orchard';

type AreaLike = Pick<CultivarArea, 'cultivar_name' | 'cultivar_trade_name' | 'cultivars'>;

/**
 * What is planted in a cultivar area, as one line: "Gala (Brookfield)", or
 * for a mixed block planned by row and position "Gala, Fuji, Granny Smith".
 *
 * `cultivars` is the server's list (its cultivar_area_cultivars view): a
 * mixed block's positions, else its one cultivar. An older server sends no
 * list, and the area's cultivar is used. Null when nothing is planted yet.
 */
export function areaCultivarLabel(area: AreaLike): string | null {
  const list = area.cultivars;
  if (!list) {
    if (!area.cultivar_name) return null;
    return area.cultivar_trade_name ? `${area.cultivar_name} (${area.cultivar_trade_name})` : area.cultivar_name;
  }
  if (list.length === 0) return null;
  if (list.length === 1) {
    const c = list[0];
    return c.trade_name ? `${c.name} (${c.trade_name})` : c.name;
  }
  return list.map((c) => c.name).join(', ');
}

/** More than one cultivar grows here. */
export function isMixedArea(area: Pick<CultivarArea, 'cultivars'>): boolean {
  return (area.cultivars?.length ?? 0) > 1;
}
